module.exports = __webpack_public_path__ + "img/Security.75764981.png";